function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "8yr716fcra",
  d: "M39.942 12.652c1.056 2.484 1.64 5.216 1.64 8.083 0 11.452-9.309 20.736-20.791 20.736-.388 0-.774-.01-1.157-.032l8.406-14.558c1.413-1.656 2.265-3.801 2.265-6.146 0-3.417-1.811-6.412-4.528-8.083zm-36.597-3.2l8.78 15.208c1.497 3.282 4.814 5.565 8.666 5.565 1.54 0 2.994-.365 4.28-1.013l-6.977 12.086C7.885 39.979 0 31.276 0 20.735 0 16.574 1.23 12.7 3.345 9.451zm17.446 3.903c4.087 0 7.4 3.304 7.4 7.38 0 4.077-3.313 7.38-7.4 7.38s-7.4-3.303-7.4-7.38c0-4.076 3.313-7.38 7.4-7.38zM20.79 0c8.053 0 15.038 4.567 18.49 11.246H20.439c-4.975.187-8.976 4.179-9.155 9.142L4.239 8.186C8.036 3.211 14.037 0 20.79 0z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-620 -424) translate(480 263) translate(140 161) translate(.546 .86)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "y317qz1ogb",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#8yr716fcra"
})), /*#__PURE__*/React.createElement("use", {
  fill: "#56AFEF",
  xlinkHref: "#8yr716fcra"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FA6758",
  d: "M3.132 6.253L11.457 22.261 12.55 17.598 15.605 13.722 20.89 12.327 26.26 12.021 45.981 11.749 25.52 -2.522 11.428 0.038z",
  mask: "url(#y317qz1ogb)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F5D923",
  d: "M23.912 11.962L27.103 15.23 29.156 18.498 29.156 21.243 27.622 25.466 18.637 42.347 23.398 42.608 33.737 39.13 41.025 30.124 43.466 21.073 42.419 13.98 41.106 12.102z",
  mask: "url(#y317qz1ogb)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#6CE84E",
  d: "M3.233 8.251L6.812 14.255 12.006 22.136 14.623 26.488 16.893 28.19 19.822 29.019 23.799 28.928 26.079 28.009 17.961 42.808 3.691 37.281 -2.243 24.36 -1.588 14.652z",
  mask: "url(#y317qz1ogb)"
}))))));

var SvgChrome = function SvgChrome(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChrome, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chrome.491f0725.svg";
export { ForwardRef as ReactComponent };